import { Link } from "react-router-dom";
import { Badge, Spinner } from "@/components/ui";
import { SECTION_LABELS } from "@/config/constants";
import { getStrapiMedia } from "@/lib/strapi";
import { ROUTES } from "@/routes/paths";
import { useExploreStore, sectionFilter } from "@/features/explore";
import { useDesigners } from "../hooks/useDesigners";

export function DesignersPage() {
  const section = useExploreStore((s) => s.section);
  const { data, isLoading, error } = useDesigners({
    populate: "logo",
    filters: sectionFilter(section),
  });

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner />
      </div>
    );
  }
  if (error) return <p className="text-destructive">Failed to load designers.</p>;

  const designers = data?.items ?? [];

  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold text-foreground">Designers</h1>
      {designers.length === 0 ? (
        <p className="text-muted-foreground">No designers yet.</p>
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {designers.map((d) => {
            const logo = getStrapiMedia(d.logo);
            return (
              <Link
                key={d.documentId}
                to={ROUTES.DESIGNER_DETAIL(d.documentId)}
                className="rounded-lg border border-border bg-card p-5 transition-colors hover:border-primary"
              >
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full bg-secondary">
                    {logo ? (
                      <img src={logo} alt={d.name} className="h-full w-full object-cover" />
                    ) : (
                      <span className="text-lg font-medium text-muted-foreground">
                        {d.name?.[0] ?? "?"}
                      </span>
                    )}
                  </div>
                  <div className="min-w-0">
                    <p className="truncate font-medium text-foreground">{d.name}</p>
                    {d.speciality && (
                      <p className="truncate text-sm text-primary">{d.speciality}</p>
                    )}
                  </div>
                </div>
                <div className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
                  {d.country && <span>{d.country}</span>}
                  {d.section && (
                    <Badge variant="primary">{SECTION_LABELS[d.section] ?? d.section}</Badge>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default DesignersPage;
